import SwiperCarousel from "./swiperCarousel";
new SwiperCarousel();